// extracted by mini-css-extract-plugin
export var chatHtmlText = "_tm-2";
export var chatLink = "_tm-0";
export var chatText = "_tm-1";